import styled from "styled-components";
import { theme } from "@themes";

export const ContentFields = styled.div`
  display: flex;
  padding: 10px 0;
  label {
    font-weight: 600;
    font-size: 13px;
    color: ${({ theme }) => theme.primary.purple} !important;
  }
  input::placeholder,
  textarea::placeholder {
    color: rgba(46, 46, 46, 0.4);
    font-size: 13px;
  }
  .editor-class {
    height: 220px !important;
  }
  .rdw-list-dropdown,
  .rdw-text-align-dropdown {
    z-index: 9;
  }
`;

export const ButtonSubjectVariables = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 8em;
  height: 43.21px;
  margin: 0 0.5em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonBodyVariables = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 8em;
  height: 43.21px;
  margin: 0 0.5em;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentControlVariables = styled.div`
  display: flex;
`;

export const ContentButtonsVariables = styled.div`
  display: flex;
  margin-left: 2.5em;
`;

export const ContentButtons = styled.div`
  display: flex;
  margin: 20px 0;
  width: 100%;
  height: 44px;
  justify-content: flex-end;
`;
export const ButtonSave = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  max-width: 129px;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primaryBorder};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  max-width: 129px;
  height: 43.21px;
  margin: 0 10px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
